export default "__VITE_ASSET__0296d91a__"